import React from 'react';
import PropTypes from 'prop-types';
import { ConfigMenuItemProps } from '../../../types';
import MenuItem from '../MenuItem';
import './index.scss';

const MenuBucket = ({ item, children, eventTracker }) => (
    <ul className="menu-bucket">
        <MenuItem item={item} className="linked-title" eventTracker={eventTracker} />
        {children}
    </ul>
);

MenuBucket.propTypes = {
    item: ConfigMenuItemProps,
    children: PropTypes.node,
    eventTracker: PropTypes.object,
};

export default MenuBucket;
